import { HttpErrorResponse } from "@angular/common/http";

export class CustomHttpError {
  constructor(public httpError: HttpErrorResponse, public traceId: string) {}
}
